import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { Language } from '../interfaces/language';

@Injectable({
  providedIn: 'root',
})
/**
 * Idea for later: https://www.npmjs.com/package/all-iso-language-codes
 */
export class LanguageCodesService {
  public availableLanguageCodes: string[] = ['eng', 'hun'];
  public availableLanguages: Language[];

  constructor(private readonly translateService: TranslateService) {
    this.availableLanguages = this.availableLanguageCodes.map((code) => ({
      code,
      name: this.getNameByCode(code),
    }));
  }

  getNameByCode(code: string): string {
    return this.translateService.instant(`LANGUAGE.${code}`);
  }
}
